var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leading-none mt-auto mb-2 text-shadow-white-3"},[_c('div',{staticClass:"text-7xl",domProps:{"innerHTML":_vm._s(_vm.time)}}),_vm._v(" "),_c('div',{staticClass:"text-3xl"},[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }